import React from "react";
import { RightPanel } from "../../../../../../components/RightPanel";
import { IBusinessPolicyToolFloater } from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businesPolicyToolFloater.types";
import { ToolFloater } from "./ToolFloater";

interface IToolFloaterRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  toolFloaterNumber?: number;
  onSaveSuccess: (toolFloater: IBusinessPolicyToolFloater) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IBusinessPolicyToolFloater;
  disableApiCalls?: boolean;
}

export const ToolFloaterRightPanel: React.FC<IToolFloaterRightPanelProps> = (
  props
) => {
  const {
	customerId,
	customerPolicyId,
	toolFloaterNumber,
	onClose,
	onSaveSuccess,
	readonly,
	staticStatusValue,
	created_from,
	initialData,
	disableApiCalls,
  } = props;

  return (
	<>
	  <RightPanel
		heading="Tool Floater"
		//subHeading="Add notes or comments"
		open={true}
		onClose={onClose}
		width="80%"
	  >
		<ToolFloater
		  customerId={customerId}
		  customerPolicyId={customerPolicyId}
		  toolFloaterNumber={toolFloaterNumber}
		  onSaveSuccess={onSaveSuccess}
		  readOnly={readonly}
		  fromRightPanel
		  staticStatusValue={staticStatusValue}
		  created_from={created_from}
		  initialData={initialData}
		  disableApiCalls={disableApiCalls}
		/>
	  </RightPanel>
	</>
  );
};
